import ModalFooter from "@/modules/common/components/modals/modal-footer";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { FormFooterExtraAction } from "@/modules/lead-page/types";
import { muiTheme } from "@/styles/theme";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Box, Button, CircularProgress } from "@mui/material";
import Grid from "@mui/material/GridLegacy";

const actionButtonBaseSx = {
  textTransform: "none",
  padding: `${nawyTheme.nawy.spacing.sm} ${nawyTheme.nawy.spacing.md}`,
  borderRadius: nawyTheme.nawy.radius.lg,
  alignItems: "center",
  justifyContent: "center",
  minWidth: "fit-content",
  whiteSpace: "nowrap",
  ...muiTheme.typography.h4_med,
};

const FormFooter = ({
  isLoadingSubmition,
  handleClose,
  confirmText,
  disabled,
  extraAction,
}: {
  isLoadingSubmition: boolean;
  handleClose: () => void;
  confirmText: string;
  disabled?: boolean;
  extraAction?: FormFooterExtraAction;
}) => {
  const screen = useScreenSize();
 
  const applyButtonGroup = extraAction ? (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        flexWrap: "wrap",
        justifyContent: "flex-end",
      }}
    >
      <Button
        type="submit"
        variant="outlined"
        color="primary"
        disabled={isLoadingSubmition || disabled}
        data-testid="edit-status-save"
        sx={{
          ...actionButtonBaseSx,
          width: "120px",
        }}
      >
        {isLoadingSubmition && !extraAction.isSubmitting ? (
          <CircularProgress
            sx={{
              maxHeight: "20px",
              maxWidth: "20px",
            }}
          />
        ) : (
          confirmText
        )}
      </Button>
      <Button
        type="button"
        variant="contained"
        color="primary"
        onClick={extraAction.onClick}
        disabled={isLoadingSubmition || disabled}
        data-testid={extraAction.testId ?? "edit-status-save-create-tracks"}
        sx={{
          ...actionButtonBaseSx,
          ":disabled": {
            backgroundColor: "primary",
          },
        }}
      >
        {isLoadingSubmition && extraAction.isSubmitting ? (
          <CircularProgress
            sx={{
              maxHeight: "20px",
              maxWidth: "20px",
              color: muiTheme.colorSchemes.light.palette.main.white,
            }}
          />
        ) : (
          extraAction.text
        )}
      </Button>
    </Box>
  ) : undefined;

  return (
    <>
      <Grid
        sx={{
          marginTop: "3rem",
        }}
        item
        mobile={12}
      >
        {screen.isMobile ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              bottom: "0",
              left: "0",
              right: "0",
              gap: 1,
              maxWidth: "100vw",
              backgroundColor:
                muiTheme.colorSchemes.light.palette.background.blue1,
              padding: 2,
              zIndex: 9,
            }}
          >
            <ModalFooter
              isSubmitting={isLoadingSubmition}
              confirmText={confirmText}
              handleClose={handleClose}
              disabledConfirmButton={disabled}
              applyButton={applyButtonGroup}
              confirmTestId="edit-status-save"
              cancelTestId="edit-status-cancel"
            />
          </Box>
        ) : (
          <ModalFooter
            isSubmitting={isLoadingSubmition}
            confirmText={confirmText}
            handleClose={handleClose}
            disabledConfirmButton={disabled}
            applyButton={applyButtonGroup}
            confirmTestId="edit-status-save"
            cancelTestId="edit-status-cancel"
          />
        )}
      </Grid>
    </>
  );
};

export default FormFooter;
